import SearchBox from "../common/input/SearchBox";
import { usePairHeader } from "../../hooks/usePairsHook";
import {
    HeaderWrapper,
    Headers,
    Favorite,
    HeaderText,
    Column,
    Row,
} from "../../styles/PairBoxStyles";
import SortButton from "./SortButton";
import { usePairsQuery } from "../../services/react-query/useMarketQuery";


const PairHeader = ({ onSortClicked }) => {

    const { data: pairs } = usePairsQuery()

    const {
        filters, activeSortTab,
        onHeaderClicked, onCloseSearchClicked,
        onInputValueChange, onSortButtonClicked
    } = usePairHeader(onSortClicked)


    return (
        <HeaderWrapper>
            <SearchBox
                id={'pairs-search'}
                onInputValueChange={onInputValueChange}
                searchValue={filters.search}
                onCloseSearchClicked={onCloseSearchClicked}
            />
            <Headers id={'pairs-pair'}>
                <Favorite
                    id={'pairs-favorite'}
                    header={true}
                    active={filters.pair === "starred"}
                    onClick={() => onHeaderClicked("starred")}
                />
                {/* {pairs?.map(title => (
                    <HeaderText key={title.id} active={filters.pair === title.id} onClick={() => onHeaderClicked(title.id)}>
                        {title.id.toUpperCase()}
                    </HeaderText>
                ))} */}
                <HeaderText active={filters.pair === "irt"} onClick={() => onHeaderClicked("irt")}>
                    IRT
                </HeaderText>
            </Headers>
            <Row header={true}>
                {sortTypes.map((type, index) => {

                    return (
                        <Column id={`pairs-${type}`} key={type} index={index} header={true}>
                            <SortButton
                                text={type}
                                onSortClicked={(type, direction) =>
                                    onSortButtonClicked(index, type, direction)
                                }
                                active={activeSortTab === index}
                            />
                        </Column>
                    )
                })}
            </Row>
        </HeaderWrapper>
    )
}

const sortTypes = ["coin", "price", "_24change"]

export default PairHeader;
